<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'blue darken-2'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.activate')"
        :icon="error ? 'mdi-alert' : 'mdi-power-plug'"
        @press="press"
    />
</template>

<script>
export default {
    name: 'WBtnActivate',
    props: {
        show: Boolean,
        loading: Boolean,
        disabled: Boolean,
        error: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>